export const GrainOverlay = () => (
  <div className="grain pointer-events-none fixed inset-0 z-[100]" aria-hidden data-testid="grain-overlay" />
);
